<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle.jade
	//-transition(appear, name="fade", mode="out-in")
	.election-component.election-keyseats(v-if="keySeatData", :election-embed="embed", :class="{ loading: loading }")
		template(v-if="title")
			GroupTitle(v-if="embed", :title="titleText", :year="year", :fineprint="percentCounted")
			h3.election-keyseats_title(v-else) {{ title }}

		YearNav(v-if="embed", @update:changeYear="changeYear", :embed="embed", :year="year")

		.election-component_content.election-keyseats_content
			DistrictDataTable(v-for="keySeat in keySeatData", v-if="keySeat", :district="keySeat", :key="keySeat['number']")
			LoadingOverlay(v-if="embed", :loading="loading")
</template>
<script>
	import DistrictDataTable from './DistrictDataTable.vue'
	import LoadingOverlay from './LoadingOverlay.vue'
	import GroupTitle from './GroupTitle.vue';
	import YearNav from './YearNav.vue';

	export default {
		name: "election-keyseats",
		props: {
			keySeats: {
				type: Array,
				required: true
			},
			title: {
				type: String
			},
			embed: {
				type: Boolean
			},
			currentYear: {

			}
		},
		data() {
			return {
				year: this.currentYear
			}
		},
		computed: {
			titleText() {
				return this.year ? `${this.year}: ${this.title}` : this.title;
			},
			loading() { return this.$store.state.loading; },
			keySeatData() {
				return this.keySeats.map( (id) => this.$store.getters.getDistrictById(id, this.year) )
			},
			percentCounted() {
				const percentRollCounted = this.$store.getters.percentCounted(this.year);
				return percentRollCounted ? `${percentRollCounted}% counted` : null;
			}
		},
		components: { DistrictDataTable, LoadingOverlay, GroupTitle, YearNav },
		methods: {
			changeYear(year) {
				this.year = year;
				this.$store.dispatch('loadResults', year)
			}
		}
	}
</script>
<style lang="scss" >
@import "src/_commons/assets/scss/global-sass";
@import "node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle";
@import "node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle-dependencies";

.election-keyseats {

	&_title {
		margin: 0 $m-spacing;

		@include MQ_SmallMedium() {
			margin: 0 0 $m-spacing-x3;
		}
	}

	&_content {
		@include MQ_MediumLarge {
			line-height: 0.8rem;
		}
		@include MQ_SmallOnly() {
			line-height: 1rem;
		}
	}

	.district-results {
		margin: $m-spacing-x2 0;
		padding: 6px;
	}



	@include MQ_SmallMedium {
		&.sidebar {
			margin-top: $m-spacing-x4;
			padding-top: $m-spacing-x4;
			border-top: 2px solid #ddd;

			.district-results {
				font-size: 14px;
				overflow: hidden;
				margin:0;
			}
		}
	}

	@include MQ_LargeOnly() {
		&.sidebar {
			border-left: 3px solid #ddd;
			padding-left: $m-spacing-x3;
			margin-left: $m-spacing-x3;
			flex: 0 0 316px;
			display: flex;
			flex-direction: column;

			.district-results {
				flex:1 1 auto;
			}
		}

		&.sidebar &_content {
			display: flex;
			flex-direction: column;
			flex: 1;
		}
	}



	@include MQ_MediumOnly {
		&.sidebar &_content {
			display: flex;
			justify-content: space-between;
		}
	}
	/*
	&[election-embed] {
		@include MQ_MediumLarge {
			margin: $m-spacing-x3 auto;
		}
		@include MQ_SmallOnly() {
			margin: $m-spacing-x2 auto;
		}

		padding: $m-spacing;
		&:after {
			content: "";
			display: none; // block;
			height: 1px;
			margin: 0 $m-spacing;
			background: rgba(0,0,0,0.2);
		}

	}

	&[election-embed] .tge-componenttitle {
		&:before,
		&:after {
			background: rgba(0,0,0,0.2);
		}
		&_text { font-size: inherit; }
	}
	*/

	&[election-embed] &_content {
		position: relative;


		.district-results {
			transition: all 0.3s ease;
		}
		@include MQ_MediumLarge(){
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.district-results {
				padding: 6px;
				flex-basis: 45%;
				flex-basis: calc(50% - #{$m-spacing-x2});
			}
		}
	}
	&[election-embed].loading .district-results {
		// filter: blur(2px);
		// opacity: 0.5;
	}
}

</style>



// WEBPACK FOOTER //
// KeySeats.vue?1d38bdfe